import { useMemo } from 'react';
import { useAuthStore } from '../stores/useAuthStore';
import { getServicePalette } from '../lib/theme';

export function useServicePalette() {
  const isTakeAway = useAuthStore((s) => s.isTakeAway);
  return useMemo(() => getServicePalette(isTakeAway ? 'take-away' : 'dine-in'), [isTakeAway]);
}

export default useServicePalette;
